<script>
    export default {
        name: 'CompanyCardMini',
        props: ['company_prop'],
        data() {
            return {
                company: {},
                sports: [],
                first_sports: [],
                other_sports_count: 0,
            }
        },
        mounted() {
            this.company = this.company_prop
            this.getSports();
            this.first_sports = this.getFirstSports();
            this.other_sports_count = this.sportsCount();
        },
        methods: {
            companyHref(company) {
                return route('company.show', company.slug)
            },
            showCompany(company) {
                location.href = route('company.show', company.slug)
            },            
            hasLogo(company) {
                if (company.original_logo_path) {
                    return company.original_logo_path;
                }
                if (this.images && typeof this.images[0] !== 'undefined') {
                    return this.images[0].file_path;
                }
                return company.logo_path;
            },

            getFirstSports() {
                return this.sports.slice(0,3)
            },

            getSports() {
                this.company.courses.forEach(course => {
                    let check = this.sports.filter(i => i.id == course.sport.id)

                    if (check.length == 0) {
                        this.sports.push(course.sport)
                    }
                })
            },
            sportsCount(){
                return this.sports.slice(3, this.sports.length).length;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/company/CompanyCardMini.vue